import { makeStyles } from '@mui/styles';
import React from 'react';
import { Link } from 'react-router-dom';

import { getRoutePathname } from '#app/Handler/RouteHandler';

const CheckEmail: React.FC = () => {
  const classes = useStyles();

  return (
    <div>
      <p>
        Si un compte correspondant à votre adresse email existe, un email vient de vous être envoyé contenant un lien
        que vous pouvez utiliser pour réinitialiser votre mot de passe. Ce lien expirera dans 1 heure.
      </p>

      <p>
        Si vous ne recevez pas d'email, veuillez vérifier votre dossier de spam ou{' '}
        <a href={getRoutePathname('forgot_password_request')} className={classes.retryLink}>
          réessayer
        </a>
        .
      </p>
      <Link to={getRoutePathname('api_default')} className={classes.buttonStyle}>
        Aller à la page de connexion
      </Link>
    </div>
  );
};

const useStyles = makeStyles({
  retryLink: {
    color: ' #007bff',
    textDecoration: 'underline',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  buttonStyle: {
    opacity: 0.9,
    padding: '7px 12px',
    borderRadius: '4px',
    backgroundColor: '#0484c7',
    color: '#FFFFFF',
    cursor: 'pointer',
  },
});

export default CheckEmail;
